import React from "react";
import { Link } from "react-router-dom";
import "./Card.css";
import img1 from "../../assets/images/MedicationSync/OIP-removebg-preview.png";
import img2 from "../../assets/images/MedicationSync/OIP-removebg-preview.png";


const data = [
  {
    id: 1,
    image: img1,
    title: "Independent Vs Chain",
    link:"/service/alf",
  },
  {
    id: 2,
    image: img2,
    title: "Medicare Part B & D",
    link:"/service/pharmacy",
  },
  {
    id: 3,
    image: img2,
    title: "Vitamins",
    link:"/service/pharmacy",
  },
  {
    id: 4,
    image: img2,
    title: "Personal Attention",
    link:"/service/pharmacy",
  },
];

const Card2Copy = () => {
  return (
    <div className="card-container">
      {data.map((item) => {
        return (
          <div className="card" key={item.id}>
            <h1 className="title">{item.title}</h1>
            <img className="card-image" src={item.image} alt={item.title} />
            <div className="text1">
              <div className="text-content">
                <Link className="body-btn" to={item.link}>
                    Read More
                  </Link>
              </div>
            </div>
            <svg
              className="chevron"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 35"
              width="30"
            >
              <path
                d="M5 30L50 5l45 25"
                fill="none"
                stroke="#000"
                stroke-width="5"
              />
            </svg>
          </div>
        );
      })}
    </div>
  );
};

export default Card2Copy;
